export default "__VITE_ASSET__VuJlMrRhsck015XHJTM3ow__"